import { render } from "./CodeAnalyticsView.vue?vue&type=template&id=5f894149&scoped=true"
import script from "./CodeAnalyticsView.vue?vue&type=script&lang=js"
export * from "./CodeAnalyticsView.vue?vue&type=script&lang=js"

import "./CodeAnalyticsView.vue?vue&type=style&index=0&id=5f894149&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f894149"]])

export default __exports__